module.exports = __webpack_public_path__ + "img/capa-site 02.11cac362.jpg";